import React, { useState, useEffect } from "react";
import Popup from "../../../components/popup/Popup";
import Form from "../Settings/CertificationForm/Form";
import { General, Licensed, Tickets } from "./CertificationData";
import {
  AdminPageTitle,
  AdminMainText,
  AdminHeaderAction,
  AdminFormSecondaryAction,
} from "../../AdminDashboard/shared/adminUx";
import {
  BUSINESS_FORM_SECTION_GAP_CLASS,
  BUSINESS_LIST_PAGE_TITLE_CLASS,
} from "../shared/businessLayoutSpec";

const CertificationLayout = () => {
const contentShellClass = "w-full min-w-0 max-w-full mx-auto";
  const sectionClass = `text-offblack ${contentShellClass} pb-2 border-b border-b-mediumgray`;
  const gridClass = `grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-x-2 sm:gap-x-4 gap-y-16 ${contentShellClass} ${BUSINESS_FORM_SECTION_GAP_CLASS}`;

  return (
    <div className="mb-5 flex flex-col w-full min-w-0 max-w-full">
      <AdminPageTitle className={`${sectionClass} ${BUSINESS_LIST_PAGE_TITLE_CLASS}`}>Badges</AdminPageTitle>
      <div className={gridClass}>
        {General?.map((item, index) => (
          <CertificationsDesign
            key={index}
            heading={item.heading}
            image={item.image}
            status={item.status}
          />
        ))}
      </div>

      <div className="mt-20">
        <AdminPageTitle className={sectionClass}>Licensed</AdminPageTitle>
      </div>
      <div className={gridClass}>
        {Licensed?.map((item, index) => (
          <CertificationsDesign
            key={index}
            heading={item.heading}
            image={item.image}
            status={item.status}
          />
        ))}
      </div>

      <div className="mt-20">
        <AdminPageTitle className={sectionClass}>Tickets</AdminPageTitle>
      </div>
      <div className={gridClass}>
        {Tickets?.map((item, index) => (
          <CertificationsDesign
            key={index}
            heading={item.heading}
            image={item.image}
            status={item.status}
          />
        ))}
      </div>
    </div>
  );
};

export default CertificationLayout;

const CertificationsDesign = ({ heading, image, status }) => {
  const [form, setForm] = useState(false);

  useEffect(() => {
    document.body.style.overflow = form ? "hidden" : "visible";
    if (!form) document.body.style.width = "auto";
  }, [form]);

  const action =
    status === "Remove" ? (
      <AdminFormSecondaryAction type="button" onClick={() => setForm(true)}>
        {status}
      </AdminFormSecondaryAction>
    ) : (
      <AdminHeaderAction type="button" onClick={() => setForm(true)}>
        {status}
      </AdminHeaderAction>
    );

  return (
    <>
      <div className="flex flex-col items-center justify-center min-w-0 w-full px-1">
        <img className="w-[50px] h-[50px] flex-shrink-0" src={image} alt={heading} />
        <div className="my-2 md:my-3 text-center min-w-0 w-full">
          <AdminMainText className="text-offblack break-words">{heading}</AdminMainText>
        </div>
        <div className="md:hidden">{action}</div>
        <div className="hidden md:block">{action}</div>
      </div>
      {form ? (
        <Popup
          setTrigger={() => setForm(false)}
          ShowCrossButton={true}
          cross={true}
          onClose={() => setForm(false)}
          businessDashboard={true}
          hideLogoInHeader={true}
        >
          <Form
            closePopup={() => setForm(false)}
            secondMainHeading="Certification submission confirmed!"
            secondP="We've successfully received your certification at Trades Poster. An email notification will be dispatched to you upon completion of the verification process. Please note, our team might take up to 10 business days to review and verify your information. Your understanding and patience are greatly valued."
          />
        </Popup>
      ) : null}
    </>
  );
};
